module.exports = __webpack_public_path__ + "sz.svg?05258322baef0ec298f9c68de93f85a0";